// newInnstallReducer
export const newInstallsMonths = {
  0: 162000,
  1: 162000,
  2: 202905,
  3: 270912,
  4: 330390,
  5: 413416,
  6: 413416,
  7: 413416,
  8: 413416,
  9: 413416,
  10: 413416,
  11: 413416,
  12: 413416,
  13: 413416,
  14: 413416,
  15: 413416,
  16: 413416,
  17: 413416,
  18: 413416,
  19: 413416,
  20: 413416,
  21: 413416,
  22: 413416,
  23: 413416,
  24: 413416,
  25: 413416,
  26: 413416,
  27: 413416,
  28: 413416,
  29: 413416,
  30: 413416,
  31: 413416,
  32: 413416,
  33: 413416,
  34: 413416,
  35: 413416,
  36: 413416,
};

export const organicMonths = {
  0: 42000,
  1: 42000,
  2: 52905,
  3: 70912,
  4: 90390,
  5: 113416,
  6: 113416,
  7: 113416,
  8: 113416,
  9: 113416,
  10: 113416,
  11: 113416,
  12: 113416,
  13: 113416,
  14: 113416,
  15: 113416,
  16: 113416,
  17: 113416,
  18: 113416,
  19: 113416,
  20: 113416,
  21: 113416,
  22: 113416,
  23: 113416,
  24: 113416,
  25: 113416,
  26: 113416,
  27: 113416,
  28: 113416,
  29: 113416,
  30: 113416,
  31: 113416,
  32: 113416,
  33: 113416,
  34: 113416,
  35: 113416,
  36: 113416,
};

export const installMembersMonths = {
  0: 0.5,
  1: 0.5,
  2: 0.5,
  3: 0.5,
  4: 0.5,
  5: 0.5,
  6: 0.5,
  7: 0.5,
  8: 0.5,
  9: 0.5,
  10: 0.5,
  11: 0.5,
  12: 0.5,
  13: 0.5,
  14: 0.5,
  15: 0.5,
  16: 0.5,
  17: 0.5,
  18: 0.5,
  19: 0.5,
  20: 0.5,
  21: 0.5,
  22: 0.5,
  23: 0.5,
  24: 0.5,
  25: 0.5,
  26: 0.5,
  27: 0.5,
  28: 0.5,
  29: 0.5,
  30: 0.5,
  31: 0.5,
  32: 0.5,
  33: 0.5,
  34: 0.5,
  35: 0.5,
  36: 0.5,
};

export const paidInstallsMonths = {
  0: 35,
  1: 35,
  2: 35,
  3: 35,
  4: 37,
  5: 37,
  6: 37,
  7: 37,
  8: 37,
  9: 37,
  10: 37,
  11: 37,
  12: 37,
  13: 37,
  14: 37,
  15: 37,
  16: 37,
  17: 37,
  18: 37,
  19: 37,
  20: 37,
  21: 37,
  22: 37,
  23: 37,
  24: 37,
  25: 37,
  26: 37,
  27: 37,
  28: 37,
  29: 37,
  30: 37,
  31: 37,
  32: 37,
  33: 37,
  34: 37,
  35: 37,
  36: 37,
};

export const paidMonths = {
  0: 0,
  1: 0,
  2: 0,
  3: 0,
  4: 0,
  5: 0,
  6: 0,
  7: 0,
  8: 0,
  9: 0,
  10: 0,
  11: 0,
  12: 0,
  13: 0,
  14: 0,
  15: 0,
  16: 0,
  17: 0,
  18: 0,
  19: 0,
  20: 0,
  21: 0,
  22: 0,
  23: 0,
  24: 0,
  25: 0,
  26: 0,
  27: 0,
  28: 0,
  29: 0,
  30: 0,
  31: 0,
  32: 0,
  33: 0,
  34: 0,
  35: 0,
  36: 0,
};

export const organicPercentageMonths = {
  0: 0,
  1: 0,
  2: 0,
  3: 0,
  4: 0,
  5: 0,
  6: 0,
  7: 0,
  8: 0,
  9: 0,
  10: 0,
  11: 0,
  12: 0,
  13: 0,
  14: 0,
  15: 0,
  16: 0,
  17: 0,
  18: 0,
  19: 0,
  20: 0,
  21: 0,
  22: 0,
  23: 0,
  24: 0,
  25: 0,
  26: 0,
  27: 0,
  28: 0,
  29: 0,
  30: 0,
  31: 0,
  32: 0,
  33: 0,
  34: 0,
  35: 0,
  36: 0,
};

export const paidPercentageMonths = {
  0: 0,
  1: 0,
  2: 0,
  3: 0,
  4: 0,
  5: 0,
  6: 0,
  7: 0,
  8: 0,
  9: 0,
  10: 0,
  11: 0,
  12: 0,
  13: 0,
  14: 0,
  15: 0,
  16: 0,
  17: 0,
  18: 0,
  19: 0,
  20: 0,
  21: 0,
  22: 0,
  23: 0,
  24: 0,
  25: 0,
  26: 0,
  27: 0,
  28: 0,
  29: 0,
  30: 0,
  31: 0,
  32: 0,
  33: 0,
  34: 0,
  35: 0,
  36: 0,
};

// cumulativeSubscribersReducer
export const cumulativeSubscribersMonths = {
  0: 0,
  1: 0,
  2: 0,
  3: 0,
  4: 0,
  5: 0,
  6: 0,
  7: 0,
  8: 0,
  9: 0,
  10: 0,
  11: 0,
  12: 0,
  13: 0,
  14: 0,
  15: 0,
  16: 0,
  17: 0,
  18: 0,
  19: 0,
  20: 0,
  21: 0,
  22: 0,
  23: 0,
  24: 0,
  25: 0,
  26: 0,
  27: 0,
  28: 0,
  29: 0,
  30: 0,
  31: 0,
  32: 0,
  33: 0,
  34: 0,
  35: 0,
  36: 0,
};

export const annualToTotalSubscribersMonths = {
  0: 60,
  1: 60,
  2: 60,
  3: 60,
  4: 60,
  5: 60,
  6: 60,
  7: 60,
  8: 60,
  9: 60,
  10: 60,
  11: 60,
  12: 60,
  13: 60,
  14: 60,
  15: 60,
  16: 60,
  17: 60,
  18: 60,
  19: 60,
  20: 60,
  21: 60,
  22: 60,
  23: 60,
  24: 60,
  25: 60,
  26: 60,
  27: 60,
  28: 60,
  29: 60,
  30: 60,
  31: 60,
  32: 60,
  33: 60,
  34: 60,
  35: 60,
  36: 60,
};
//----------------------------------------------------------------------------------------------------
export const monthlyToTotalSubscribersMonths = {
  0: 40,
  1: 40,
  2: 40,
  3: 40,
  4: 40,
  5: 40,
  6: 40,
  7: 40,
  8: 40,
  9: 40,
  10: 40,
  11: 40,
  12: 40,
  13: 40,
  14: 40,
  15: 40,
  16: 40,
  17: 40,
  18: 40,
  19: 40,
  20: 40,
  21: 40,
  22: 40,
  23: 40,
  24: 40,
  25: 40,
  26: 40,
  27: 40,
  28: 40,
  29: 40,
  30: 40,
  31: 40,
  32: 40,
  33: 40,
  34: 40,
  35: 40,
  36: 40,
};

export const journeyToSubscriptionMonth = {
  0: 50,
  1: 50,
  2: 50,
  3: 50,
  4: 50,
  5: 50,
  6: 50,
  7: 50,
  8: 50,
  9: 50,
  10: 50,
  11: 50,
  12: 50,
  13: 50,
  14: 50,
  15: 50,
  16: 50,
  17: 50,
  18: 50,
  19: 50,
  20: 50,
  21: 50,
  22: 50,
  23: 50,
  24: 50,
  25: 50,
  26: 50,
  27: 50,
  28: 50,
  29: 50,
  30: 50,
  31: 50,
  32: 50,
  33: 50,
  34: 50,
  35: 50,
  36: 50,
};

// cumulativeMembersReducer
export const cumulativeMembersMonths = {
  0: 10,
  1: 10,
  2: 10,
  3: 10,
  4: 10,
  5: 10,
  6: 10,
  7: 10,
  8: 10,
  9: 10,
  10: 10,
  11: 10,
  12: 10,
  13: 10,
  14: 10,
  15: 0,
  16: 0,
  17: 0,
  18: 0,
  19: 0,
  20: 0,
  21: 0,
  22: 0,
  23: 0,
  24: 0,
  25: 0,
  26: 0,
  27: 0,
  28: 0,
  29: 0,
  30: 0,
  31: 0,
  32: 0,
  33: 0,
  34: 0,
  35: 0,
  36: 0,
};

export const registrationMonths = {
  0: 81000,
  1: 81000,
  2: 101453,
  3: 135456,
  4: 165195,
  5: 206708,
  6: 206708,
  7: 206708,
  8: 206708,
  9: 206708,
  10: 206708,
  11: 206708,
  12: 206708,
  13: 206708,
  14: 206708,
  15: 206708,
  16: 206708,
  17: 206708,
  18: 206708,
  19: 206708,
  20: 206708,
  21: 206708,
  22: 206708,
  23: 206708,
  24: 206708,
  25: 206708,
  26: 206708,
  27: 206708,
  28: 206708,
  29: 206708,
  30: 206708,
  31: 206708,
  32: 206708,
  33: 206708,
  34: 206708,
  35: 206708,
  36: 206708,
};

export const totalMonths = {
  0: 81000,
  1: 81000,
  2: 182453,
  3: 317909,
  4: 483104,
  5: 689812,
  6: 689812,
  7: 689812,
  8: 689812,
  9: 689812,
  10: 689812,
  11: 689812,
  12: 689812,
  13: 689812,
  14: 689812,
  15: 689812,
  16: 689812,
  17: 689812,
  18: 689812,
  19: 689812,
  20: 689812,
  21: 689812,
  22: 689812,
  23: 689812,
  24: 689812,
  25: 689812,
  26: 689812,
  27: 689812,
  28: 689812,
  29: 689812,
  30: 689812,
  31: 689812,
  32: 689812,
  33: 689812,
  34: 689812,
  35: 689812,
  36: 689812,
};

// cumulativeInstallsReducer

export const cumulativeInstallsMonths = {
  0: 0,
  1: 0,
  2: 0,
  3: 0,
  4: 0,
  5: 0,
  6: 0,
  7: 0,
  8: 0,
  9: 0,
  10: 0,
  11: 0,
  12: 0,
  13: 0,
  14: 0,
  15: 0,
  16: 0,
  17: 0,
  18: 0,
  19: 0,
  20: 0,
  21: 0,
  22: 0,
  23: 0,
  24: 0,
  25: 0,
  26: 0,
  27: 0,
  28: 0,
  29: 0,
  30: 0,
  31: 0,
  32: 0,
  33: 0,
  34: 0,
  35: 0,
  36: 0,
};

export const installMonths = {
  0: 162000,
  1: 162000,
  2: 202905,
  3: 270912,
  4: 330390,
  5: 413416,
  6: 413416,
  7: 413416,
  8: 413416,
  9: 413416,
  10: 413416,
  11: 413416,
  12: 413416,
  13: 413416,
  14: 413416,
  15: 413416,
  16: 413416,
  17: 413416,
  18: 413416,
  19: 413416,
  20: 413416,
  21: 413416,
  22: 413416,
  23: 413416,
  24: 413416,
  25: 413416,
  26: 413416,
  27: 413416,
  28: 413416,
  29: 413416,
  30: 413416,
  31: 413416,
  32: 413416,
  33: 413416,
  34: 413416,
  35: 413416,
  36: 413416,
};

export const churnMonth = {
  0: 20,
  1: 20,
  2: 20,
  3: 20,
  4: 20,
  5: 20,
  6: 20,
  7: 20,
  8: 20,
  9: 20,
  10: 20,
  11: 20,
  12: 20,
  13: 20,
  14: 20,
  15: 20,
  16: 20,
  17: 20,
  18: 20,
  19: 20,
  20: 20,
  21: 20,
  22: 20,
  23: 20,
  24: 20,
  25: 20,
  26: 20,
  27: 20,
  28: 20,
  29: 20,
  30: 20,
  31: 20,
  32: 20,
  33: 20,
  34: 20,
  35: 20,
  36: 20,
};
